import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateArrayValue'
})
export class TranslateArrayValuePipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  /**
   * 資料庫儲存值轉換成呈現在畫面上的值，通常會用在下拉選單上
   *
   * @param value 資料庫儲存值
   * @param datas 要比對的資料，通常是下拉選單的 array 資料
   * @param valueField  資料庫儲存值要比對資料的哪個屬性名稱
   * @param displayField 要顯示的值要取資料的哪個屬性的值
   * @returns 呈現在畫面上的值
   */
  transform(value: string, datas: any[], valueField: string, displayField: string): string {

    let displayValue: string = '';

    // 如果儲存的值是空的就不做
    if (!value) {
      return displayValue;
    }

    const currentLang = this.translateService.currentLang.split('-')[1];

    // 比對資料
    datas.some(data => {
      // 支援查詢兩層，欄位會用 . 隔開
      if (valueField.indexOf('.') > 0) {
        const fields: string[] = valueField.split('.');
        // 先取資料第一層然後比對裡面資料
        const displayData = data[fields[0]]?.find((subData: { [x: string]: string; }) => {
          // 如果值相等就回傳這筆資料物件 ( 第二層的 )
          return subData[fields[1]] == value;
        });

        // 如果有比對到資料
        if (displayData) {
          const displayFieldName = displayField.split('.')[1];
          const langFieldName = displayFieldName.concat(currentLang[0].toUpperCase()).concat(currentLang.substring(1).toLowerCase());
          // 把資料裡面要顯示的欄位的值取出來
          displayValue = displayData[langFieldName] ? displayData[langFieldName] : displayData[displayFieldName];
        }
        // 如果 displayValue 有取到值下面的判斷就會是 true，結束 some()
        return displayValue;
      } else {
        // 如果值相等就回傳這筆資料物件
        if (data[valueField] == value) {
          // 把資料裡面要顯示的欄位的值取出來
          const displayFieldName = displayField;
          const langFieldName = displayFieldName.concat(currentLang[0].toUpperCase()).concat(currentLang.substring(1).toLowerCase());
          displayValue = data[langFieldName] ? data[langFieldName] : data[displayFieldName];
        }
        // 如果 displayValue 有取到值下面的判斷就會是 true，結束 some()
        return displayValue;
      }
    });

    return displayValue;
  }

}
